import { MarkEventAsRead } from '@/core/graphql/types'
import { gql, useMutation } from '@apollo/client'
import { Mutation } from '@/core/graphql/types'

type MarkEventAsReadMutation = Pick<Mutation, 'markEventAsRead'>

type CreateMarkEventAsReadMutationVariables = {
  payload: MarkEventAsRead
}

const MARK_EVEVNT_AS_READ = gql`
  mutation MarkEventAsRead($payload: MarkEventAsRead!) {
    markEventAsRead(payload: $payload) {
      _id
      type
      object_id
      object_type
      recipients {
        read
        type
        userId
      }
    }
  }
`

export const useMarkAsReadMutation = () => {
  const [markEventAsRead, { data, ...restMutationResult }] = useMutation<MarkEventAsReadMutation, CreateMarkEventAsReadMutationVariables>(MARK_EVEVNT_AS_READ)

  const event = data?.markEventAsRead

  return { ...restMutationResult, markEventAsRead, event }
}
